<!-- <section id="main-section" class="lightgrey-bg">
    <div class="smallContainer mg-auto">

        <article> -->

<!-- Trigger/Open The Modal -->
<form [formGroup]="feedbackForm">
    <!-- <button id="myBtn">Open Modal</button> -->
    <!-- The Modal -->
    <div id="feedback__Modal" class="feedback__modal" style="display: flex;">
        <!-- Modal content -->
        <div class="modal-content">
            <div class="feedback__Modal--topsection" style="text-align: center;">
                <ng-container *ngIf="completedItemObj?.type == 'COURSE'">
                    <img width="100" src="assets/images/upgradRed/feedback.png" alt="" style="margin: auto;">
                <p class="feedback__Modal--username">Well Done {{user?.firstName}}!</p>
                <p class="feedback__Modal--coursename">Congratulations on completing the {{completedItemObj?.type == 'COURSE' ? 'Course' : completedItemObj?.type}}. <br> <strong>{{completedItemObj?.title |
                  titlecase}}</strong>.</p>
                </ng-container>
                <ng-container *ngIf="completedItemObj?.type == 'MASTERCLASS'">
                    <img width="100" src="assets/images/upgradRed/feedback.png" alt="" style="margin: auto;">
                <p class="feedback__Modal--username">Thank you, {{user?.firstName}}!</p>
                <p class="feedback__Modal--coursename">Congratulations on completing the Masterclass. <br><strong>{{completedItemObj?.title | titlecase }}</strong></p>
                </ng-container>

                <ng-container *ngIf="completedItemObj?.type == 'COURSE'">
                    <p class="feedback__Modal--desc">Your feedback is valuable for us and will help us improve this course. Please share your insights with us to proceed further.</p>
                    <!-- <p class="feedback__Modal--desc">To view score, please share your feedback and help
                        us improve.</p> -->
                </ng-container>
            </div>
            <div class="feedback__Modal--bottomsection" style="text-align: center;">
                <p class="feedback__Modal--rating--header" *ngIf="completedItemObj?.type == 'COURSE'">How was your
                    experience with the course?</p>
                <p class="feedback__Modal--rating--header" *ngIf="completedItemObj?.type == 'MASTERCLASS'">How was your
                    experience with the masterclass?</p>
                <div class="rating-icon">
                    <span class="icon-star cursor-pointer" *ngFor="let item of stars; let i=index"
                        [ngClass]="{'rating-selected': starSelected >= i+1}" (click)="startClicked(i+1)">
                        <span *ngIf="starSelected == i+1 && starSelected == 1">Unhappy</span>
                        <span *ngIf="starSelected == i+1 && starSelected == 2">Dissatisfied</span>
                        <span *ngIf="starSelected == i+1 && starSelected == 3">Okay</span>
                        <span *ngIf="starSelected == i+1 && starSelected == 4">Satisfied</span>
                        <span *ngIf="starSelected == i+1 && starSelected == 5">Thrilled</span>
                    </span>
                    <!-- <span class="icon-star" [ngClass]="{'rating-selected': starSelected >= 2}" (click)="startClicked(2)"></span>
                                <span class="icon-star" [ngClass]="{'rating-selected': starSelected >= 3}" (click)="startClicked(3)"></span>
                                <span class="icon-star" [ngClass]="{'rating-selected': starSelected >= 4}" (click)="startClicked(4)"></span>
                                <span class="icon-star" [ngClass]="{'rating-selected': starSelected == 5}" (click)="startClicked(5)"></span> -->
                </div>
                <!-- <div class="rating-icon">
                                <span class="icon-star rating-selected"></span>
                                <span class="icon-star rating-selected"></span>
                                <span class="icon-star"></span>
                                <span class="icon-star"></span>
                                <span class="icon-star"></span>
                            </div> -->
                <div class="feedback__Modal--negative--item" *ngIf="starSelected <= 3">
                    <p class="title">What could be made better?</p>
                    <ul class="item--list">
                        <ng-container *ngIf="completedItemObj?.type == 'COURSE'">
                            <li [ngClass]="{'selected': tagValue.includes(t)}" style="cursor: pointer;"
                                *ngFor="let t of tagsCourses; let i=index" (click)="courseTagSelected(i)">{{t}}</li>
                        </ng-container>
                        <ng-container *ngIf="completedItemObj?.type == 'MASTERCLASS'">
                            <li [ngClass]="{'selected': tagValue.includes(t)}" style="cursor: pointer;"
                                *ngFor="let t of tagsMasterclass; let i=index" (click)="masterclassTagSelected(i)">{{t}}
                            </li>
                        </ng-container>

                        <!-- <li class="selected">Course Assessments</li>
                                    <li>Course Videos</li>
                                    <li>Course Navigation</li> -->
                    </ul>
                </div>
                <div class="feedback__Modal--comment">
                    <textarea name="" id="" formControlName="text"
                        placeholder="Anything else you'd like to share? (optional)"></textarea>
                    <button (click)="saveFeedback();">SUBMIT</button>
                </div>
            </div>
            <!-- This button is to show confetti design -->
            <div class="" id="thirdAnimation"></div>
            <!-- <div class="button buttonThree">
                <button id="buttonThree">Press Me!</button>
            </div> -->
        </div>
    </div>
</form>

<!-- </article>
    </div>
</section> -->
